/** Packages **/
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { UnmountClosed as Collapse } from "react-collapse";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";

import { openTimeSearchConfig } from "./../../settings/settings";
import * as utils from "../../utilities/calendarUtilities";
import * as actions from "./../../data/calendarActivities/actions";
import Pairing from "./../CalendarActivities/Pairing";
import Reserve from "./../CalendarActivities/Reserve";
import AddToCalendar from "./components/AddToCalendar";
import AddRequest from "./components/AddRequest";
import "./styles.scss";
import {
  buildAddRequestData,
  isActivityEndsInBidSessionPeriod,
  isActivityStartsInBidSessionPeriod,
} from "./components/AddRequest/helpers";
import { RESERVE_BID_SCOPE } from "../../data/constants";

const OpenTimeSearchItem = (props) => {
  const {
    activity,
    bidSession,
    bidPreferencesTotalEntries,
    handleActionPreference,
    showNotification,
    bidSessionId,
    leftPosition,
    activityWidth,
    selectedActivity,
    fromAddButton,
    setFromAddButton,
  } = props;
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState({});

  // Close the details when lastBidScopeUsed changes
  useEffect(() => {
    const handleStorageChange = () => {
      setOpen(false);
    };

    // Listen for storage events (changes from other tabs/windows)
    window.addEventListener('storage', handleStorageChange);

    // Also set up a custom event listener for same-tab changes
    window.addEventListener('lastBidScopeUsedChanged', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('lastBidScopeUsedChanged', handleStorageChange);
    };
  }, []);

  const showDrawerDetails = () => {
    const { fetchActivityDetails, activity, activityStationId } = props;

    if (!open) {
      fetchActivityDetails(activity.activityId, activityStationId)
        .then((response) => {
          setDetails(response.data);
          setOpen(!open);
        })
        .catch((e) => console.log(e.response));
    } else {
      setOpen(!open);
    }
  };

  const buildShowPairingDetailButton = () => {
    if (props.isHead) {
      return " ";
    }
    return !open ? (
      <ExpandMoreIcon fontSize="small" />
    ) : (
      <NavigateBeforeIcon fontSize="small" />
    );
  };
  const buildClassName = () => {
    if (props.isHead) {
      return "Table-Head";
    }
    return "Table-Item";
  };
  const buildPairingDetailContent = (nbSeniorOutbids) => {
    const { activity } = props;
    const isRSV = activity.type === openTimeSearchConfig.activityTypes.RSV;
    const isTRP = activity.type === openTimeSearchConfig.activityTypes.TRP;
    let content = "";
    if (Object.keys(details).length > 0) {
      if (isTRP) {
        content = (
          <Pairing
            pairing={details.pairing}
            name={details.activityName}
            days={details.days}
            startDate={details.startInterval}
            endDate={details.endInterval}
            nbSeniorOutbids={nbSeniorOutbids}
            attributes={details.groupActivitiesType}
          />
        );
      } else if (isRSV) {
        content = (
          <Reserve
            name={details.activityName}
            startDate={details.startInterval}
            endDate={details.endInterval}
            nbSeniorOutbids={nbSeniorOutbids}
            groupActivitiesType={details.groupActivitiesType}
          />
        );
      } else {
        content = `${
          details.activityName
        } ${utils.convertActivityDetailsDateInterval(
          details.startInterval,
          details.endInterval
        )}`;
      }
    }
    return content;
  };
  const showOutbidStatus = (nbSeniorOutbids) => {
    return nbSeniorOutbids > 0 ? <span className="seniorOutbids" /> : "";
  };

  const activityStartsInSessionPeriod = isActivityStartsInBidSessionPeriod(
    activity,
    bidSession
  );
  const activityEndsInSessionPeriod = isActivityEndsInBidSessionPeriod(
    activity,
    bidSession
  );

  const isActivityEndsOrStartsInSession =
    activityStartsInSessionPeriod || activityEndsInSessionPeriod;
  let activityColor = openTimeSearchConfig.activity.TRP;
  if (activity.type === openTimeSearchConfig.activityTypes.RSV) {
    activityColor = openTimeSearchConfig.activity.RSV;
  }
  const activityStyle = {
    background: activityColor,
    left: leftPosition,
    width: activityWidth,
  };
  const className = buildClassName();
  const arrow = buildShowPairingDetailButton();
  const pairingDetailContent = buildPairingDetailContent(
    activity.nbSeniorOutbids
  );
  const {
    label,
    isPreferenceOptionActive,
    requestPreferencePayload,
    isPairingOrReserve,
  } = buildAddRequestData(activity, bidSession);

  return (
    <div>
      <div
        onClick={() => showDrawerDetails()}
        className={`OpenTime-Activity row ${className} ${
          selectedActivity ? "openedActivity" : ""
        } ${open ? "openedActivity" : ""}`}
      >
        <div className="small-1 columns outbid">
          {showOutbidStatus(activity.nbSeniorOutbids)}
        </div>
        <div className="small-1 columns">{activity.type}</div>
        <div className="small-1 columns Name">{activity.name}</div>
        <div className="small-2 columns">{props.startDate}</div>
        <div className="small-2 columns">{props.endDate}</div>
        <div className="small-1 columns Credit">
          {utils.formatCredit(activity.credit)}
        </div>
        <div className="small-2 columns Ranking">{props.ranking}</div>
        <div className="small-1 columns Layover " title={props.layover}>
          {props.layover.split(",").join(", ")}
        </div>
        <div className="small-1 columns DH">{props.deadhead}</div>
        <div className="small-1 columns end">{arrow}</div>
        <div className="OpenTime-Activity-Fill" style={activityStyle} />
      </div>
      <Collapse isOpened={open}>
        <div className="OpenTimeSearch-Details">
          <div className="expanded row">
            <div className="add-button-container">
              {isPairingOrReserve && isActivityEndsOrStartsInSession && (
                <AddToCalendar {...props} />
              )}
              {isPairingOrReserve &&
                activityStartsInSessionPeriod &&
                (isPreferenceOptionActive || bidSession.displayRequestOptions) && (
                  <AddRequest
                    label={label}
                    handleActionPreference={handleActionPreference}
                    showNotification={showNotification}
                    requestPreferencePayload={requestPreferencePayload}
                    bidmode={bidSession.bidMode}
                    bidSession={bidSession}
                    setFromAddButton={setFromAddButton}
                  />
                )}
            </div>
            <div
              className={`large-12 columns pairing-details ${
                isPairingOrReserve ? "" : "align"
              }`}
            >
              {pairingDetailContent}
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

OpenTimeSearchItem.propTypes = {
  activity: PropTypes.object.isRequired,
  bidSession: PropTypes.object.isRequired,
  isHead: PropTypes.bool,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  ranking: PropTypes.string.isRequired,
  fetchActivityDetails: PropTypes.func,
  layover: PropTypes.any,
  deadhead: PropTypes.any,
  activityStationId: PropTypes.string,
  bidPreferencesTotalEntries: PropTypes.func.isRequired,
  handleActionPreference: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  bidSessionId: PropTypes.string.isRequired,
  leftPosition: PropTypes.number.isRequired,
  activityWidth: PropTypes.number.isRequired,
  activePreferenceOptionsIds: PropTypes.array.isRequired,
  actionType: PropTypes.any,
  selectedActivity: PropTypes.bool.isRequired,
  fromAddButton: PropTypes.bool,
  setFromAddButton: PropTypes.func,
};

OpenTimeSearchItem.defaultProps = {
  isHead: false,
  fetchActivityDetails: () => {},
  activityStationId: "",
  actionType: {},
  selectedActivity: false,
  fromAddButton: false,
  setFromAddButton: () => {},
};

const mapDispatchToProps = (dispatch) => ({
  fetchActivityDetails: (activityId, activityStationId) =>
    dispatch(actions.fetchActivityDetails(activityId, activityStationId)),
});

export default connect(null, mapDispatchToProps)(OpenTimeSearchItem);
